import i18next from 'i18next';
import { CURRICULO_TIPO, _URL_FORM, abrirFormCadastro, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';

export const sintese = function (conteudo) {
    "use strict";
    var _listar = function (conteudo) {
        var panel = body.find('#panel-sintese');

        window.global.loaderPanel.show('#panel-sintese');

        var elementNull = document.getElementById("sintese-null");

        if (!isNullOrEmpty(conteudo)) {
            elementNull.className = 'hide';

            const sinteseLista = document.getElementById('sintese-lista');
            const sinteseListaMostrar = document.getElementById('sintese-lista-mostrar');
            const verMaisBtn = document.getElementById("ver-mais-btn");
            const verMenosBtn = document.getElementById("ver-menos-btn");

            sinteseLista.innerHTML = conteudo;
            sinteseListaMostrar.innerHTML = conteudo;

            panel.find('.btn-add').removeClass('hide');

            const textoCompleto = sinteseListaMostrar.textContent;
            const limiteCaracteres = 200;

            // sempre reinicia recolhido: senao, ao reexibir um texto ja expandido, "Ver menos" fica visivel junto do "Ver mais".
            verMenosBtn.classList.add('hide');

            if (textoCompleto.length <= 200)
                verMaisBtn.classList.add('hide');
            else {
                verMaisBtn.classList.remove('hide');

                // Inicialmente, exibir apenas a parte resumida do texto
                sinteseListaMostrar.textContent = textoCompleto.slice(0, limiteCaracteres) + '...';

                verMaisBtn.addEventListener("click", function () {
                    sinteseListaMostrar.textContent = textoCompleto;
                    verMaisBtn.classList.add('hide');
                    verMenosBtn.classList.remove('hide');
                });

                verMenosBtn.addEventListener("click", function () {
                    sinteseListaMostrar.textContent = textoCompleto.slice(0, limiteCaracteres) + '...';
                    verMenosBtn.classList.add('hide');
                    verMaisBtn.classList.remove('hide');
                });
            }
        }
        else {
            elementNull.className = '';
            document.getElementById('sintese-lista').innerHTML = '';
            document.getElementById('sintese-lista-mostrar').innerHTML = '';
            document.getElementById('ver-mais-btn').classList.add('hide');
            document.getElementById('ver-menos-btn').classList.add('hide');
        }
        window.global.loaderPanel.hide('#panel-sintese');
    };
    var _salvar = function () {
        var content = body.find('#form-sintese');
        var texto = content.find('#sintese-conteudo').val();
        window.global.loaderButton.show(content.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveSintese', cache: false,
            data: {
                Conteudo: texto
            },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('sinteseSalva'), '', { "closeButton": true });
                    _listar(texto);
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('sintese-contentform').innerHTML = '';
        goToByScroll('#panel-sintese');
        fecharFormCadastro();
    };
    var _abrir = function () {
        goToByScroll('#panel-sintese');
        window.global.loaderFull.show();
        //window.global.loaderPanel.show('#panel-sintese');
        var formulario = body.find('#sintese-contentform');
        var tipoCurriculo = CURRICULO_TIPO();
        abrirFormCadastro();
        formulario.load(_URL_FORM + "Sintese?v=3&tipo=" + tipoCurriculo, function () {
            $.validate({
                form: '#form-sintese'
            });


            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-sintese').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });
            formulario.find('#sintese-conteudo').val(body.find('#sintese-lista').html());


            formulario.find('#sintese-conteudo').restrictLength($('#maxlengthSintese'));

            function OnInput() {
                this.style.height = 0;
                this.style.height = (this.scrollHeight + 50) + "px";
            }

            const tx = document.getElementsByTagName("textarea");
            for (let i = 0; i < tx.length; i++) {
                tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight + 50) + "px;overflow-y:hidden;");
                tx[i].addEventListener("input", OnInput, false);
            }

            janelaAjuda(formulario);

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
            //window.global.loaderPanel.hide('#panel-sintese');
        });


    };

    var init = function () {
        _listar(conteudo);

        body.find('#panel-sintese').find('.btn-add').on('click', function (e) {
            _abrir();
            e.preventDefault();
        });

    }

    return init();
};

